import { convertTimestampToLuxonOrDefaultNow } from "../utils/convertTimestampToLuxonOrDefaultNow";
export const createCompany = (data) => {
    if (!assertCompany(data, "save")) {
        throw new Error("Company.save failed");
    }
    return data;
};
export function assertCompany(company, mode = "load") {
    if (!company || typeof company !== "object") {
        throw new Error("Company must be an object");
    }
    return true;
}
export const createCompanyConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(company) {
        if (!assertCompany(company, "save")) {
            throw new Error("Company.save failed");
        }
        const data = {
            ...company,
            apiVersion: 1,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(company.createdAt),
            modifiedAt: convertToFirestoreTimestampOrDefaultServerTime(company.modifiedAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const company = {
            ...data,
            id: snapshot.id,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            modifiedAt: convertTimestampToLuxonOrDefaultNow(data.modifiedAt),
        };
        if (!assertCompany(company)) {
            throw new Error("Company.load failed");
        }
        return company;
    },
});
//# sourceMappingURL=Company.js.map